import { useCallback } from 'react'
import type React from 'react'
import type { ReservationGivenPointsUsage } from '~/lib/graphql/graphql'
import { useChangeGivenPointsUsage, useDisabledGivenPointsUsageSave } from '../../store/payment'
import { useSelectedGivenPointsUsage } from '../../store/payment'

export function useSave() {
  const disabled = useDisabledGivenPointsUsageSave()
  const selected = useSelectedGivenPointsUsage()
  const checked = selected === 'SAVE'
  const change = useChangeGivenPointsUsage()
  const inactive = checked && disabled
  const changeGivenPointsUsage = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      change(e.target.value as ReservationGivenPointsUsage)
    },
    [change]
  )
  if (disabled) {
    return { disabled, checked, changeGivenPointsUsage: nop, inactive }
  }
  return { disabled, checked, changeGivenPointsUsage, inactive }
}

function nop() {}
